import React from 'react';
import { TextField } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import { useLang } from '../../util/lang';
import CheckboxOption from '../FormOptions/CheckboxOption';

/** Renders the reusable optional appliances and remark area. */
const RestorativeOptionalSection = ({ appliances, startNumber }) => {
    const { control, watch } = useFormContext();
    const get = useLang();
    const selectedAppliances = watch('optionalAppliances') || [];
    const hasSplintOption = appliances.some((appliance) => {
        const value = typeof appliance === 'string' ? appliance : appliance.value;
        return value?.toLowerCase().includes('splint');
    });

    /** Adds or removes an appliance from the shared form value. */
    const handleApplianceChange = (appliance, checked, onChange) => {
        const nextValue = checked
            ? [...selectedAppliances, appliance]
            : selectedAppliances.filter((value) => value !== appliance);
        onChange(nextValue);
    };

    return (
        <div className="restorative-optional-section">
            <div className="restorative-divider" />
            <div className="restorative-question-title">
                {startNumber}. {get('@PatientInfo.smileDesign.restorativePhase.optionalAppliances')}{' '}
                <span>({get('@PatientInfo.smileDesign.restorativePhase.optional')})</span>
            </div>
            <Controller
                name="optionalAppliances"
                control={control}
                defaultValue={[]}
                render={({ field }) => (
                    <div className="restorative-appliance-grid">
                        {appliances.map((appliance) => {
                            const value = typeof appliance === 'string' ? appliance : appliance.value;
                            const label = typeof appliance === 'string' ? appliance : appliance.label;
                            return (
                                <CheckboxOption
                                    key={value}
                                    label={label}
                                    className="restorative-checkbox-inline"
                                    selectedClassName="restorative-checkbox-selected"
                                    checked={selectedAppliances.includes(value)}
                                    onChange={(event) =>
                                        handleApplianceChange(value, event.target.checked, field.onChange)
                                    }
                                />
                            );
                        })}
                    </div>
                )}
            />
            {hasSplintOption && (
                <div className="restorative-hint restorative-splint-hint">
                    {get('@PatientInfo.smileDesign.restorativePhase.splintRemarkNotice')}
                </div>
            )}
            <div className="restorative-question-title">
                {startNumber + 1}. {get('@PatientInfo.smileDesign.restorativePhase.remark')}{' '}
                <span>({get('@PatientInfo.smileDesign.restorativePhase.optional')})</span>
            </div>
            <Controller
                name="restorationRemark"
                control={control}
                defaultValue=""
                render={({ field }) => <TextField {...field} multiline rows={4} variant="outlined" fullWidth />}
            />
        </div>
    );
};

export default RestorativeOptionalSection;
